const FAVICON_BASE = "https://www.google.com/s2/favicons";
const FAVICON_SIZE = 32;

/**
 * Returns a favicon URL for the given domain (e.g. "reddit.com").
 * Uses Google's favicon service; strips protocol if present.
 */
export function getFaviconUrl(domain: string): string {
  if (!domain?.trim()) return "";
  const normalized = domain.replace(/^https?:\/\//i, "").split("/")[0].trim();
  if (!normalized) return "";
  const params = new URLSearchParams({ domain: normalized, sz: String(FAVICON_SIZE) });
  return `${FAVICON_BASE}?${params.toString()}`;
}
